import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Api } from '../../services/Api';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class InstituteManagementService extends Api {
    url = environment.baseUrl;

    // calling login API
    public CreateInstituteApi(params): Observable<any> {
        return this.http.post(this.url + '/institute/create-institute', params);
    }
    // INSTITUTE LIST
    public instituteList(params): Observable<any> {
        return this.http.get(this.url + '/institute/institute-list', { params });
    }
    // calling country List APi
    public countryListApi(): Observable<any> {
        return this.http.get(this.url + '/location/country-list');
    }
    // calling region List Api
    public regionListApi(params): Observable<any> {
        return this.http.get(this.url + '/location/region-list', { params });
    }
    // Calling city List Api
    public cityListApi(params): Observable<any> {
        return this.http.get(this.url + '/location/city-list', { params });
    }
    // calling school type branch Api
    public SchoolBranchApi(): Observable<any> {
        return this.http.get(this.url + '/institute/get-institute-type');
    }
    // calling sales Man Api
    public instituteSalesManAPI(params): Observable<any> {
        return this.http.get(this.url + '/auth/user-list', { params });
    }
    // calling institute detail Api
    public instituteDetail(params): Observable<any> {
        return this.http.get(this.url + '/institute/get-institute/' + params);
    }
    // calling institue Update instituteUpdate
    public instituteUpdate(params): Observable<any> {
        return this.http.post(this.url + '/institute/update-institute', params);
    }
    // calling Institute poc List
    public institutePocList(params): Observable<any> {
        return this.http.get(this.url + '/institute/get-institute-type-keyword', { params });
    }
    public instituteDelete(params): Observable<any> {
        const id = params.id;
        delete params.id;
        return this.http.delete(this.url + '/institute/delete-institute/' + id, { params });
    }
    // calling upload institute logo api
    public uploadInstituteLogo(params): Observable<any> {
        return this.http.post(this.url + '/institute/uploads-institute-logo', params);
    }
    // calling approval Api
    public institupeApprovalApi(params): Observable<any> {
        return this.http.put(this.url + '/institute/institute-approval', params);
    }
    // calling renewal Api
    public institueRenewalApi(params): Observable<any> {
        return this.http.put(this.url + '/institute/institute-renewal', params);
    }
    // calling upload institute logo api
    public uploadInstituteFile(params): Observable<any> {
        return this.http.post(this.url + '/institute/uploads-institute-file', params);
    }
    // calling standard list api standardListApi
    public standardListApi(): Observable<any> {
        return this.http.get(this.url + '/standard');
    }
    // calling section list API
    public SectionListApi(): Observable<any> {
        return this.http.get(this.url + '/section');
    }
    // calling update standard section list API
    public uploadStandardSection(params: any): Observable<any> {
        return this.http.post(this.url + '/standard-sections/update-standard-sections', params);
    }
    // calling update standard section list API
    public getStandardSection(params: any): Observable<any> {
        return this.http.get(this.url + '/standard-sections/update-standard-sections', { params });
    }
    // calling verify Api
    public instituteVerifyApi(params: any): Observable<any> {
        return this.http.post(this.url + '/institute/update-institute', params);
    }
    // get additional module
    additionalModuleList() {
        return this.http.get(this.url + '/settings/');
    }
    // calling language List APi
    public getLanguageList(): Observable<any> {
        return this.http.get(this.url + '/settings/languages');
    }
    // verification Approval List verificationApprovalList
    public verificationApprovalList(params: any): Observable<any> {
        return this.http.get(this.url + '/institute/get-institute-status-keyword', { params });
    }
    // active Inactive List ActiveInactiveList
    public ActiveInactiveList(params: any): Observable<any> {
        return this.http.get(this.url + '/institute/get-institute-status', { params });
    }
    // sms provider List
    public smsProvider(): Observable<any> {
        return this.http.get(this.url + '/institute/sms-providers-list');
    }
    // boardList List
    public boardList(): Observable<any> {
        return this.http.get(this.url + '/institute/institute-boards-list');
    }
    // all INSTITUTE LIST
    public allInstituteList(params): Observable<any> {
        return this.http.get(this.url + '/institute/institute-list', { params });
    }
    // Redirect to institute url
    // public redirectToInstitute(params): Observable<any> {
    //     return this.http.post(this.url + '/super/super-Admin-login', params);
    // }
    public redirectToInstitute(params): Observable<any> {
        // return this.http.post(this.url + '/super/auto-login', params);
        return this.http.get(this.url + '/super/auto-login?token=' + JSON.stringify(params.encryptString) + '&type=' + params.demoId + '&instituteid=' + params.instituteId);
    }
    // INSTITUTE LIST
    public instituteListCount(params): Observable<any> {
        return this.http.get(this.url + '/institute/institute-list', { params });
    }
    // INSTITUTE LIST
    public instituteExport(params): Observable<any> {
        const reqOpts: any = {};
        reqOpts.responseType = 'arraybuffer';
        if (params) {
            reqOpts.params = new HttpParams();
            for (const k in params) {
                if (k) {
                    reqOpts.params = reqOpts.params.set(k, params[k]);
                }
            }
        }
        return this.http.get(this.url + '/institute/institute-list-export', reqOpts);
    }
    // export verification approval
    public exportVerification(params): Observable<any> {
        const reqOpts: any = {};
        reqOpts.responseType = 'arraybuffer';
        if (params) {
            reqOpts.params = new HttpParams();
            for (const k in params) {
                if (k) {
                    reqOpts.params = reqOpts.params.set(k, params[k]);
                }
            }
        }
        return this.http.get(this.url + '/institute/get-institute-status-keyword', reqOpts);
    }
    // export poc live
    public exportPocLive(params): Observable<any> {
        const reqOpts: any = {};
        reqOpts.responseType = 'arraybuffer';
        if (params) {
            reqOpts.params = new HttpParams();
            for (const k in params) {
                if (k) {
                    reqOpts.params = reqOpts.params.set(k, params[k]);
                }
            }
        }
        return this.http.get(this.url + '/institute/get-institute-type-keyword', reqOpts);
    }
    // export govt Csr
    public exportGovtActive(params): Observable<any> {
        const reqOpts: any = {};
        reqOpts.responseType = 'arraybuffer';
        if (params) {
            reqOpts.params = new HttpParams();
            for (const k in params) {
                if (k) {
                    reqOpts.params = reqOpts.params.set(k, params[k]);
                }
            }
        }
        return this.http.get(this.url + '/institute/get-institute-status', reqOpts);
    }
    //
    GetAcademicYearSetting(params): Observable<any> {
        return this.http.post(this.url + '/academic-year/get-institute-communicationyear-setting', params);
    }
    ChangeAcademicYearSetting(params): Observable<any> {
        return this.http.post(this.url + '/academic-year/institute-settingcomm_year', params);
    }

    AcademicList(params): Observable<any> {
        return this.http.get(this.url + '/academic-year/commyearlist', params);
    }

    public getScheduledInstituteDetails(params): Observable<any> {
        return this.http.get(this.url + '/institute/get-scheduled-institute/' + params);
    }

    public createSupportRemarks(params): Observable<any> {
        console.log('params back to the backend', params)
        return this.http.post(this.url + '/support-remarks/create-support-remarks', params);
    }

    public getSupportRemaksList(params): Observable<any> {
        return this.http.get(this.url + '/support-remarks/get-support-remarks-list', { params });
    }

    public getDefaultOtpStatusInstitute(institute_id: string): Observable<any> {
        return this.http.get(this.url + '/institute/get-default-otp-status-institute', {
            params: { institute_id }
        });
    }

    public removeDefaultOtpInstitute(params: any): Observable<any> {
        return this.http.post(this.url + '/institute/remove-default-otp-institute', params);
    }

    public setDefaultOtpInstitute(params: any): Observable<any> {
        return this.http.post(this.url + '/institute/set-default-otp-institute', params);
    }

}
